namespace $.$$ {
	$mol_style_define($bog_formigo_builder, {
		Body_content: {
			padding: $mol_gap.block,
		},
	})
}
